import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import creditReducer from "./credit.reducer";

const store = configureStore({
    reducer: creditReducer
})

export default store;
export type CreditDispatch = typeof store.dispatch;
export const useCreditDispatch = useDispatch<CreditDispatch>;